import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, combineLatest } from "rxjs";
import { map } from "rxjs/operators";

/**
 * Tracks when we're on the public profile page so the app shell
 * can hide header/footer.
 */
@Injectable({ providedIn: "root" })
export class LayoutService {
  private readonly publicProfilePage$ = new BehaviorSubject<boolean>(false);

  private readonly sideNavCollapsed$ = new BehaviorSubject<boolean>(false);
  private readonly sideNavHovered$ = new BehaviorSubject<boolean>(false);

  get isPublicProfilePage(): boolean {
    return this.publicProfilePage$.value;
  }

  get isPublicProfilePage$(): Observable<boolean> {
    return this.publicProfilePage$.asObservable();
  }

  setPublicProfilePage(visible: boolean): void {
    this.publicProfilePage$.next(visible);
  }

  setSideNavCollapsed(collapsed: boolean): void {
    this.sideNavCollapsed$.next(collapsed);
  }

  setSideNavHovered(hovered: boolean): void {
    this.sideNavHovered$.next(hovered);
  }

  /** True when side nav is wide (expanded or hover-expanded from collapsed). */
  isSideNavExpanded$: Observable<boolean> = combineLatest([
    this.sideNavCollapsed$,
    this.sideNavHovered$,
  ]).pipe(
    map(([collapsed, hovered]) => !collapsed || hovered)
  );
}
